import type { LatLng } from '~/_shared/types/latLng';

export const getGeoLink = (lat: number, lng: number) => (
  `geo:${lat},${lng}?q=${lat},${lng}`
);

export const getGoogleMapsNavigateToLatLngLink = (latLng: LatLng) => {
  const latLngString = encodeURIComponent(`${latLng.lat},${latLng.lng}`);

  return `https://www.google.com/maps/dir/?api=1&destination=${latLngString}&dir_action=navigate`;
};

export const getAppleMapsNavigateToLatLngLink = (latLng: LatLng) => {
  const latLngString = encodeURIComponent(`${latLng.lat},${latLng.lng}`);

  return `https://maps.apple.com/?daddr=${latLngString}`;
};
